import { constants, mediaQueryStyles } from "@newsela/angelou";
const { mediaQuery: mq } = mediaQueryStyles;
const { ui } = constants.colors;
export const toastCss = (isPremium: boolean) => {
  return {
    root: {
      marginInline: 8,
      marginTop: isPremium ? 140 : 65,
      [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
        marginTop: isPremium ? 80 : 65,
      },
    },
    cta: {
      background: "none",
      border: "none",
      color: ui.white[100],
      textDecoration: "underline",
      padding: 0,
      "&:hover": {
        background: "none",
      },
    },
  };
};
